export default {"src":"/_next/static/media/chevronLeft_24.f5d7d4e8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};